<script setup lang="ts">
</script>

<template>
    <footer class="bg-[#3361FF]">
        <div class="container">
            <div class="flex max-sm:flex-col max-sm:gap-4 justify-between sm:items-center  py-4">
                <img class="max-sm:w-[164px]" src="@/assets/images/landing/kpi-simplex-logo.svg" alt="Simplex KPI logo">
                <span class=" text-[#fff] text-[16px] leading-[140%] ">
                    +998 55 500 30 02
                </span>
            </div>
            <div class="flex max-sm:flex-col max-sm:gap-4 justify-between sm:items-center py-4">
                <span class="text-[#fff] text-[14px] leading-[150%] ">
                    © 2016-2025 Simplex ITC MCHJ QK. Barcha huquqlar himoyalangan
                </span>
                <a href="https://simplex.uz" target="_blank">
                    <img src="@/assets/images/landing/simplex-logo.svg" alt="Simplex ICT logo">
                </a>
            </div>
        </div>
    </footer>
</template>

<style scoped>
</style>